/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { membraneStyle } from './ro-unit-style';
import SubLine from '../createLine';
import { ArialB600, ChineseFonts, RationValWidth, getFloatVal } from '../fonts/font';
import { defaultUnitSetDict } from '../../../shared/constantVariable';

const borderColor = '#B3D3D7';
let tablewidth = 1140;
let headercount = 1;
let rowWidthInc = 3;
let defaultUnit = defaultUnitSetDict();
let ro_hp_ind = 0;

const ROStageLevelSummary = (props) => {
  const { system_units, rodata, ro_summary, tableWidth, pageWidth, serialNum, langualgeCheck, translateObject } = props;
  let { subSerialNum } = props;
  const { ro_stage_dict, ro_system_dict } = ro_summary;
  defaultUnit = system_units || defaultUnit;
  tablewidth = tableWidth;
  const herder_val = [
    translateObject('Stage'),
    translateObject('Housing'),
    translateObject('Elements'),
    translateObject('Element Type'),
    { header1: `${translateObject('Flow')} (${defaultUnit['Volume Flow']})`, header2: [translateObject('Feed'), translateObject('Conc.'), translateObject('Perm.')] },
    `${translateObject('Recovery')}                (%)`,
    `${translateObject('Flux')}                    (${defaultUnit.Flux})`,
    { header1: `${translateObject('Pressure')} (${defaultUnit.Pressure})`, header2: [translateObject('Feed'), translateObject('dP')] },
    { header1: `${translateObject('TDS')} (mg/L)`, header2: [translateObject('Feed'), translateObject('Perm.')] },
    translateObject('Last Element Beta')
  ];
  const getSingleRowWidth = (count) => {
    if (count) {
      return RationValWidth((tablewidth / headercount) * rowWidthInc / count - 2);
    }
    return RationValWidth(tablewidth / headercount) * rowWidthInc;
  };
  headercount = herder_val.length;
  const splitHeaderData = (ele) => {
    // const count = Object.keys(data).length + 1;
    return Object.prototype.toString.call(ele) === '[object Array]' ? (
      ele.map((dta, ind) => (
        <View key={ind}
          style={[
            { width: getSingleRowWidth(ele.length), borderTop: 1, borderLeft: 1, borderColor, justifyContent: 'center' },
            ind === 0 && { borderLeft: 0 },
          ]}
        >
          <Text
            style={[
              membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }
            ]}
          >
            {translateObject(dta)}
          </Text>
        </View>
      ))
    ) : (
      <View style={{ width: '100%', justifyContent: 'center' }}>
        <Text
          style={[membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }]}
        >
          {translateObject(ele)}
        </Text>
      </View>
    );
  };
  const getColumnCount = (ele) => {
    let count = 1;
    if (Object.prototype.toString.call(ele) === '[object Object]') {
      Object.keys(ele).map((data) => {
        if (Object.prototype.toString.call(ele[data]) === '[object Array]') {
          if (count < ele[data].length) {
            count = ele[data].length;
          }
        }
        return count;
      });
    }
    return count;
  };
  const createHeader = (item) => {
    return (
      <View style={[membraneStyle.tableRow, { width: RationValWidth(tablewidth) }]}>
        {item.map((ele, ind) => {
          rowWidthInc = getColumnCount(ele);
          return (
            <View key={ind}
              style={[
                membraneStyle.tableCol, { borderColor },
                ind === item.length - 1 && { borderRight: 0 },
                { width: RationValWidth((tablewidth / headercount)) },
                Object.prototype.toString.call(ele) === '[object Object]' && Object.keys(ele).length > 1 &&
                { width: getSingleRowWidth() }
              ]}
            >
              {Object.prototype.toString.call(ele) === '[object Object]' ? (
                Object.keys(ele).map((data, keyInd) => (
                  <View key={keyInd} style={[membraneStyle.flexDirection]} >
                    {splitHeaderData(ele[data], ele)}
                  </View>
                ))
              ) : (
                <View>
                  <Text style={[membraneStyle.tableCell, membraneStyle.restChild, langualgeCheck ? { fontFamily: ChineseFonts } : { fontFamily: ArialB600 }]}>
                    {translateObject(ele)}
                  </Text>
                </View>
              )}
            </View>
          );
        })
        }
      </View >
    );
  };
  const createContent = (items, parentkey) => {
    return (
      <View style={{ width: '100%' }}>
        {Object.keys(items).map((stage, typeindex) => {
          return (
            <View
              style={[
                membraneStyle.tablebodyRow1, { width: RationValWidth(tablewidth), margin: '0 auto' }
              ]}
              key={typeindex}
            >
              <View
                style={[
                  membraneStyle.flexDirection,
                  { width: RationValWidth(tablewidth) }
                ]}>
                <View style={[membraneStyle.tablebodyCol1]}>
                  <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}, { padding: '5 0' }]}>{translateObject(stage)}</Text>
                </View>
                {/* {Object.keys(items[stage]).map((data, ind) => { */}
                {['Housing', 'Elements', 'Element Type', 'Flow', 'Conc.', 'Perm.', '% Recovery', 'Flux', 'Feed Pressure', 'Pressure dp', 'Feed TDS mg/L', 'Perm TDS mg/L', 'Last Elem Beta'].map((data, ind) => {
                  return (
                    <View key={ind} style={[membraneStyle.tablebodyCol1, Object.keys(items[stage]).length - 1 === ind && { borderRight: 0 }]}>
                      {(() => {
                        if (data === 'Element Type') {
                          if (rodata[parentkey] && rodata[parentkey]['grid-data'] && rodata[parentkey]['grid-data'][typeindex] && rodata[parentkey]['grid-data'][typeindex].elementModel) {
                            return (
                              <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>
                                {rodata[parentkey]['grid-data'][typeindex].elementModel.split("").map((text, textInd) => {
                                  return <Text key={textInd}>{text}</Text>;
                                })}
                              </Text>
                            );
                          }
                          return (
                            <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>
                              {(() => {
                                if (rodata[parentkey]) {
                                  return rodata[parentkey]['grid-data'][0].elementModel.split("").map((text, textInd) => {
                                    return <Text key={textInd}>{text}</Text>;
                                  });
                                }
                                return '-';
                              })()}
                            </Text>
                          );
                        }
                        if (data === 'Flux' && defaultUnit.Flux === 'm/s') {
                          return (
                            <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>{(items[stage][data]).toExponential(2)}</Text>
                          );
                        }
                        const val = items[stage][data].toString();
                        if (val.indexOf('.') >= 0) {
                          return (
                            <Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>{translateObject(getFloatVal(items[stage][data]))}</Text>
                          );
                        }
                        return (<Text style={[membraneStyle.tableCell, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>{translateObject(items[stage][data])}</Text>);
                      })()}
                    </View>
                  );
                })}
              </View>
            </View>
          );
        })}
      </View >
    );
  };
  return (
    <View id='dynamic-height'>
      <View style={[membraneStyle.mainHeader, { width: RationValWidth(pageWidth) }]}>
        <Text style={{ ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{serialNum}. {translateObject('RO/NF Unit Stage-Level Summary')}</Text>
        <SubLine lineWidth='100%' lineHeight='24' />
        {/* I reduced the line width to accommodate the text and added a margin left. --->kranthi */}
      </View>
      <View style={[membraneStyle.textHeader, { width: RationValWidth(pageWidth), marginTop: 15, flexDirection: 'row' }]} /* bookmark={{ title: `${serialNum}.${subSerialNum} Docked Summary ` }} */ >
        {/* <SubLine lineWidth='10px' lineHeight='12' /> */}
        {/* <Text style={{ marginTop: -4, paddingLeft: 5, color: '#0062A9' }}>&#95;&#95;</Text> */}
        <Text style={{ paddingLeft: 0 }}>{serialNum}.{subSerialNum}</Text>
        <Text style={{ paddingLeft: 5, ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{translateObject('Docked Summary')}</Text>
      </View>
      {ro_system_dict['RO/NF Unit ID'].length > 0 && ro_system_dict['RO/NF Unit ID'].map((ele) => {
        if (ele.toLocaleLowerCase().indexOf('ro') >= 0 || ele.toLocaleLowerCase().indexOf('nf') >= 0) {
          return (
            <View key={`a${String(Math.random()).substring(2, 7)}`} style={{ width: RationValWidth(tablewidth), margin: '15 auto 0 auto' }}>
              <View break>
                <View style={[membraneStyle.textHeader, { flexDirection: 'row' }]}>
                  <Text style={{ paddingLeft: 0 }}>{serialNum}.{subSerialNum}.{++ro_hp_ind}</Text>
                  <Text style={{ paddingLeft: 5, ...(langualgeCheck ? { fontFamily: ChineseFonts } : {}) }}>{ele} {translateObject('Array Design')} </Text>
                </View>
                <View style={[membraneStyle.mainTable, { marginTop: 10 }]}>
                  {createHeader(herder_val)}
                  {createContent(ro_stage_dict[ele].Stage, ele)}
                </View>
              </View>
            </View>
          );
        }
        return (<Text key={`k${String(Math.random()).substring(2, 7)}`} />);
      })}
    </View>
  );
};
export default ROStageLevelSummary;